import useAuthMiddleware from "../../middlewares/AuthMiddleware";
import useMiddlewares from "../../middlewares/Middleware";
import usePermissionMiddleware from "../../middlewares/PermissionMiddleware";
import useRoleTypeMiddleware from "../../middlewares/RoleTypeMiddleware";
import useRouteValidator from "./RouteValidator";

/**
 * @returns {{ validate: () => boolean|{ to: string, replace: boolean }}}
 */
export function useThemeSettingsRouteValidator() {
  return useRouteValidator(
    useMiddlewares([
      useAuthMiddleware(),
      useRoleTypeMiddleware(["superadmin", "user"]),
      usePermissionMiddleware(["theme_settings.update", "theme_settings.read.screen"]),
    ])
  );
}
